import { apiList } from "../api/apiList";
import axiosInstance from "../api/axiosInstance";
import axiosInstance2 from "../api/axiosInstance2";

const userService = {
  login: (payload) => axiosInstance.post(apiList.loginApi, payload),
  getUserList: () => axiosInstance2.get(`${apiList.getUserListWithDetailsApi}`),
  updateUserBalance: (payload,type) => axiosInstance2.put(`${apiList.updateUserBalanceApi}/${type}`, payload),
  resetPassword: (payload) => axiosInstance2.post(`${apiList.resetPasswordApi}`, payload),
  getUserTransaction: (payload) => axiosInstance2.put(apiList.userTransactionApi, payload),
  lockUnlockUser: (payload) => axiosInstance2.post(apiList.userLockApi, payload),
};

export default userService;
